<template>
    <BlockConfig title="Tabella misure"
        :valid="valid"
        @handleSave="handleSave"
        @restore="restore">
        <v-form v-model="valid">
            <div class="d-flex my-2">
                <v-text-field dense outlined
                    label="nome prova*"
                    :rules="[rules.mandatory]" 
                    v-model="config_data.title"
                ></v-text-field>
                <v-text-field dense outlined
                    label="nr. misure*"
                    :rules="[rules.mandatory]" 
                    v-model="config_data.min_readings"
                    placeholder="6"
                ></v-text-field>
            </div>
                <!-- <v-layout row wrap ml-2 mr-2>
                    <v-flex xs3>
                        <v-text-field dense outlined
                        v-model="config_data.minTrials"
                        class="ma-2"
                       
                        :rules="[rules.mandatory]" 
                        label="nr. misure minimo"
                        placeholder="6" 
                        readonly
                        />
                    </v-flex>
                    <v-flex
                    xs6 
                    offset-xs3
                    >
                        <span v-for="(item,index) in config_data.weightPerc" :key="index">
                            <v-flex shrink xs12 md6 pl-6 >
                                <v-text-field dense outlined :label="index+1+' ° misura'" placeholder="" :rules="[rules.mandatory]" v-model="config_data.weightPerc[index]"></v-text-field>
                            </v-flex>
                        </span>
                    </v-flex> 
                </v-layout> -->
            <div>
                <v-label>etichette<span class="caption"> - (ordine fisso)</span></v-label>
                <div class="d-flex mt-2 flex-wrap">
                    <v-text-field dense outlined label="posizione" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.divs"></v-text-field>
                    <v-text-field dense outlined label="massa" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.mass"></v-text-field>
                    <v-text-field dense outlined label="indicazione" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.reading"></v-text-field>
                    <v-text-field dense outlined label="carico addizionale" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.addLoad"></v-text-field>
                    <v-text-field dense outlined label="P" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.p"></v-text-field>
                    <v-text-field dense outlined label="errore" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.error"></v-text-field>
                    <v-text-field dense outlined label="errore corretto" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.error_corr"></v-text-field>
                    <v-text-field dense outlined label="MPE" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.mpe"></v-text-field>
                    <v-text-field dense outlined label="esito" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.result"></v-text-field>
                </div>
            </div>
            <div>
            <v-container class="ma-0 pa-0">
                <v-row no-gutters >
                    <v-col cols="6" class="d-flex align-stretch">
                        <v-card class="elevation-2 mr-2 flex-grow-1 flex-shrink-0" >
                            <v-radio-group class="mx-4" v-model="config_data.zero_device">
                                <template v-slot:label>
                                    <div><span class="font-weight-bold">zero tracking </span><span class="caption">(valore di default)</span></div>
                                </template>
                                    <v-radio class="mx-2" value="on"><template v-slot:label>
                                        <div>acceso</div></template></v-radio>
                                    <v-radio class="mx-2" value="off"><template v-slot:label>
                                        <div>spento</div></template></v-radio>
                                    <v-radio class="mx-2" value="out"><template v-slot:label>
                                        <div>fuori zona intervento</div></template></v-radio>
                            </v-radio-group>
                            </v-card>
                    </v-col>
                    <v-col cols="6" class="d-flex align-stretch ">
                        <v-card class="ml-2 elevation-2 flex-grow-1 flex-shrink-0" >
                            <v-radio-group class="mx-4" v-model="config_data.hi_res">
                                <template v-slot:label>
                                    <div><span class="font-weight-bold">alta risoluzione </span><span class="caption">(valore di default)</span></div>
                                </template>
                                <v-radio class="mx-2" value="on"><template v-slot:label>
                                    <div>acceso</div></template></v-radio>
                                <v-radio class="mx-2" value="off"><template v-slot:label>
                                    <div>spento</div></template></v-radio>
                            </v-radio-group>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </v-form>
</BlockConfig>
</template>

<script>
import {ConfigMixin} from '../../../../utils/configMixin_new'
import BlockConfig from '../../../../components/utils/BlockConfig'

export default {
    components: {BlockConfig},
    mixins: [ConfigMixin],
    data(){
        return {
            o_data: {
                title: this.data.block.label,
                zero_device: 'out',
                hi_res: 'on',
                weightPerc: [],
                min_readings: null,
                headers: {
                    'divs': 'Divisioni',
                    'mass': 'Massa',
                    'reading': 'Indicazione',
                    'addLoad': 'Add. Load',
                    'p': 'P',
                    'error': 'Errore',
                    'error_corr': 'Errore corr.',
                    'mpe': 'MPE',
                    'result': 'Esito'
                }

            }
        }
    }
}
</script>
